<template>
    <div class="h-piece">
        <div class="h-pieceIn2 n-xiao">
            <div class="h-pieceTitle2 " style="margin-left:10px">
                <h1>用户单位</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine">
                    <el-form :model="addr" label-position="right" :inline="true" ref="add"
                             class="demo-ruleForm h-formbLine">
                        <el-form-item label="单位名称" class="h-elformWrap-2" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                            <el-input v-model="addr.deptName" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="渠道" class="h-elformWrap-2">
                          <brselect
                              style="width:2rem;"
                              category="channel_classification"
                              :v="addr.deptSourceChannel2"
                              v-model="addr.deptSourceChannel2"
                              clearable
                              @change="changeChannel($event)"
                              placeholder="--请选择--">
                          </brselect>
                        </el-form-item>
                        <el-form-item label="用户分类" class="h-elformWrap-2">
                          <el-select v-model="addr.schoolTypeName2" :v="addr.schoolTypeName2" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                                     @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                            <el-option v-for="item in addressTypeList"
                                       :key="item.id"
                                       :label="item.userUnit"
                                       :value="item.userUnit">
                            </el-option>
                          </el-select>

                        </el-form-item>
                        <el-form-item label="省" class="h-elformWrap-2" prop="province">
                            <el-select v-model="addr.province" @change="handleItemChange1" placeholder="省"  style="width: 68%;">
                                <el-option
                                        v-for="item in shenglist"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="市" class="h-elformWrap-2">
                            <el-select v-model="addr.city" @change="handleItemChange2"
                                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                       placeholder="市"  style="width: 68%;">
                                <el-option
                                        v-for="item in arealist2"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="区" class="h-elformWrap-2">
                            <el-select v-model="addr.area"
                                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                                       placeholder="区" style="width: 68%;" @change="handleItemChange3">
                                <el-option
                                        v-for="item in arealist3"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="上级" class="h-elformWrap-2" prop="stVal" label-width="100">
                            <treeselect
                                :multiple="false"
                                :options="options"
                                style="width: 100%;"
                                :flat="true"
                                :default-expand-level="1"
                                placeholder="请选择"
                                v-model="stVal"
                            />
                            <treeselect-value :value="stVal" />
                        </el-form-item>
                        <el-form-item label="详细地址" class="h-elformWrap-2">
                            <el-input v-model="addr.address"></el-input>
                        </el-form-item>
                      <el-form-item label="地标性" class="h-elformWrap-2" prop="landmark" label-width="100"
                                    :rules="[{ required: true, message: '请选择地标性', trigger: 'change'},]">
                        <el-select v-model="addr.landmark" placeholder="请选择" clearable>
                          <el-option label="KA" value="KA"></el-option>
                          <el-option label="省级" value="省级"></el-option>
                          <el-option label="地市级" value="地市级"></el-option>
                          <el-option label="区县级及以下" value="区县级及以下"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="anniu">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
                    <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">重新提交</el-button>
                    <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
                </el-row>
            </div>
        </div>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    // import the component
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    props:["taskId","instid","taskstatus"]

    export default {
        components:{
            Treeselect
        },
        data() {
            return {
                taskstatus: null,
                addr: {
                    deptName: '',
                    deptType: '',
                    leader: '',
                    phone: '',
                    email: '',
                    province: '',
                    city: '',
                    area: '',
                    spyj:'',
                    address: '',
                    instid: '' ,
                    taskId: '',
                    deptSourceChannel:'',
                    countryId: '',
                    country: '',
                    provinceId: '',
                    province: '',
                    cityId: '',
                    landmark:'',
                    city: '',
                    areaId: '',
                    area: '',
                    parentCode:'',
                    subFlag:'',
                    schoolType:null,
                  //渠道版本2.0
                  deptSourceChannel2:'',
                  //用户分类版本2.0
                  schoolType2:'',
                  schoolTypeName2:'',
                },
              address:{
                name: '',
                provinceCenter:'',
              },
                form: {
                    spyj:''
                },
                showhistory: false,
                id: null,
                shenglist: [],
                arealist2:[],
                arealist3: [],
                addressTypeList:[],
                options:[],
                stVal:null,
                proSelect: {
                    pcode: 0,
                    level: 1,
                },
            }
        },
        methods: {
            saveOrSubmit(v) {
                if (v == '0') {
                    if (this.$route.query.f == '1') {
                        this.$router.back();
                        return;
                    }
                    this.$emit('refreshSelf',{close:true,refresh:false});
                    return;
                }else if(v == '1'){
                    this.addr.taskId = this.$route.query.taskid;
                    this.addr.spyj = this.form.spyj;
                    var data = this.addr
                    ss.nxAddress.approveAddress(data).then(rd => {
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    })
                }else if(v == '2'){
                    if (!this.form.spyj) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }
                    this.addr.spyj = this.form.spyj;
                    this.addr.taskId = this.$route.query.taskid;
                    var data = this.addr
                    ss.nxAddress.rejectAddress(data).then(rd => {
                        this.$msg.alerts("提交成功！",()=>{
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            this.$router.go(-1);
                        })
                    })
                }
            },
            viewpress(r) {
                this.showhistory = true;
            },
            selectAddress(id) {
                var addrId = id;
                ss.nxAddress.selectByInstid(addrId).then(rd => {
                    console.log("rddddd",rd)
                    this.addr = rd.msg;
                })
            },
            //获取当前登录人创建的所有父级单位
            getParentInfo(){
                ss.nxAddress.getParentInfo().then(rd =>{
                    this.options = rd.msg;
                })
            },
            //省份选择器
            handleItemChange1(o){
                this.addr.provinceId = o;
                this.address = _.find(this.shenglist,{code:this.addr.provinceId});
                this.addr.province = this.address.name;
                ss.Dictservice.areaTreelist({code:o}).then(rd => {
                    console.log("rddddddd",rd.zlist)
                    this.addr.city = '';
                    this.addr.area = '';
                    this.arealist2 = rd.zlist;
                    this.arealist3 = [];
                })
            },
            handleItemChange2(o){
                this.addr.cityId = o;
                this.address = _.find(this.arealist2,{code:this.addr.cityId});
              this.addr.city = this.address.name;
                if ('1' == this.address.provinceCenter){
                  this.addr.landmark = '省级'
                }else if (null != this.addr.deptName && (this.addr.deptName.indexOf('市') != -1 && this.addr.deptName.indexOf('区') == -1)){
                  this.addr.landmark = '地市级'
                }else {
                  this.addr.landmark = '区县级及以下'
                }
              this.addr.area = '';
                this.arealist3 = _.find(this.arealist2,{code:o}).zlist
                console.log("arealist3",this.arealist3)
                this.arealist4 = []
            },
            handleItemChange3(o){
                this.addr.areaId = o;
                this.address = _.find(this.arealist3,{code:this.addr.areaId});
                this.addr.area = this.address.name;
              if ('KA' != this.addr.landmark && '省级' != this.addr.landmark){
                if (null != this.addr.deptName && ((this.addr.deptName.indexOf('市') != -1 && this.addr.deptName.indexOf('区') == -1) || '市辖区' == this.addr.area)){
                  this.addr.landmark = '地市级'
                }else {
                  this.addr.landmark = '区县级及以下'
                }
              }
            },
            loadArea(i) {
                ss.Dictservice.arealist(this.proSelect).then(rd => {
                    this.shenglist = rd;
                    // for(let i = 0; i < this.shenglist.length; i++){
                    //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
                    // }
                    console.log("shenglist",this.shenglist)
                })
            },
            //重新提交
            commitCreate(){
                this.$refs['add'].validate((valid1) => {
                    if (valid1) {
                        this.$msg.confirm("确认提交？", () => {
                            this.submitForm();
                        })
                    } else {
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });
            },
            //提交方法
            submitForm(){
                this.addr.subFlag = '重新提交';
                this.addr.countryId = '156';
                this.addr.country = '中国';
                this.addr.provinceId = this.addr.provinceId.substring(0,6);
                this.addr.cityId = this.addr.cityId.substring(0,6);
                this.addr.areaId = this.addr.areaId.substring(0,6);
                this.addr.parentCode = this.stVal;
                this.addr.instid = this.$route.query.instid
                this.addr.taskId = this.$route.query.taskid;
                var data = this.addr;
                ss.nxAddress.insertAddress(data).then(rd => {
                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        this.$router.go(-1);
                    })
                    this.closeDialog();
                })
            },
            //返回
            backtolist() {
                this.$router.go(-1);
            },
            //渠道改变
            changeChannel(value){
              console.log("value",value)
              ss.nxAddress.getAddressTypeByChannel2(value.code).then(rd =>{
                this.addressTypeList = rd.msg;
                this.addr.schoolTypeName2 = '';
              })
            },
            changeSchoolType(value){
              this.addr.schoolTypeName2 = value;
            },
        },
        created() {
            /*this.instid = this.instid;
            this.taskstatus = this.taskstatus;*/
            if (this.$route.query.taskstatus == 0) {
                this.taskstatus = '0'
            }
            this.instid = this.$route.query.instid
            this.id = this.$route.query.taskid;
            this.addr.taskId = this.$route.query.taskid;
            this.selectAddress(this.$route.query.instid);
            this.loadArea();
            this.getParentInfo();
        },
    }
</script>
<style scoped>
    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }
    .n-two .h-formbLine .h-elformWrap-3 {
        width: 33.333%;
    }
    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.3rem;
    }
</style>
